import { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { Landing } from './pages/Landing'
import { Legal } from './pages/Legal'
import { NotFound } from './pages/NotFound'
import { data as privacyData, html as privacyHtml } from './content/privacy.md'
import { data as termsData, html as termsHtml } from './content/terms.md'

/** Client-side navigation should land at the top of the new page. */
function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/privacy"
          element={<Legal data={privacyData} html={privacyHtml} path="/privacy" />}
        />
        <Route path="/terms" element={<Legal data={termsData} html={termsHtml} path="/terms" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}
